// extracted by mini-css-extract-plugin
export var bullet = "_sj-q";
export var bulletText = "_sj-p";
export var bullets = "_sj-k";
export var callout = "_sj-g";
export var calloutBody = "_sj-i";
export var calloutLabel = "_sj-h";
export var checkIcon = "_sj-m";
export var checkList = "_sj-j";
export var checkSvg = "_sj-n";
export var checkText = "_sj-o";
export var fieldCard = "_sj-1";
export var fieldDescription = "_sj-5";
export var fieldHeader = "_sj-3";
export var fieldTitle = "_sj-4";
export var finalNote = "_sj-s";
export var flow = "_sj-x";
export var flowArrow = "_sj-v";
export var flowStep = "_sj-u";
export var helperText = "_sj-r";
export var inlineTitle = "_sj-t";
export var listItem = "_sj-l";
export var noteBody = "_sj-8";
export var noteBodyText = "_sj-9";
export var noteCard = "_sj-2";
export var noteIcon = "_sj-6";
export var noteTitle = "_sj-7";
export var productChoices = "_sj-w";
export var radioDot = "_sj-d";
export var radioDotSelected = "_sj-e";
export var radioDotSvg = "_sj-f";
export var selectableCard = "_sj-b";
export var selectableCardSelected = "_sj-c";
export var strongText = "_sj-a";
export var subHeading = "_sj-0";